import {VisuallyHiddenAnchor} from 'components/accessibility';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';
import TestProps from 'types/TestProps';

interface Props extends TestProps {
  destination?: string | undefined;
  linkText?: string | undefined;
}

const SkipLink = ({destination, linkText, 'data-testid': dataTestId}: Props) => {
  const skipTo = destination ? destination : '#mainContent';
  const text = linkText ? linkText : intlFormatSingleMessage(LOCALIZED_TRANSLATIONS.SKIP_LINK_TEXT);

  return (
    <VisuallyHiddenAnchor href={skipTo} data-testid={dataTestId}>
      {text}
    </VisuallyHiddenAnchor>
  );
};

export default SkipLink;

const LOCALIZED_TRANSLATIONS = {SKIP_LINK_TEXT: 'Skip to main content'};
